module.exports = "/_next/static/images/22-1-e4fba5bb141626b73d0376ec916d29fa.svg";